import React from "react";
import { makeStyles } from "@material-ui/core";
import theme from "../assets/theme";

const useStyle = makeStyles((theme) => ({
  optionWrapperDiv: {
    borderRadius: "12px",
    position: "relative",
    border: (props) => props.border || `2px solid ${theme.palette.info.main}`,
    width: "inherit",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
    transition: "all 0.3s ease",
    
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12)",
    },
  },

  overlayOptions: {
    position: "absolute",
    height: "-webkit-fill-available",
    opacity: "0.15",
    zIndex: 1,
    borderRadius: "10px",
    margin: (props) => props.margin || "-16px 0px 2px -10px",
    transition: "width 0.3s ease",
  },
  legendColor: {
    color: theme.palette.text.secondary,
    fontSize: "12px",
    fontWeight: "500",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    padding: "2px 8px",
    borderRadius: "8px",
    border: `1px solid ${theme.palette.info.main}`,
    zIndex: 2,
    position: "relative",
  },
}));
const Fieldset = ({ value = "", ...props }) => {
  const classes = useStyle(props);
  return (
    <fieldset className={classes.optionWrapperDiv}>
      <div
        className={classes.overlayOptions}
        style={{
          width: `${value}%`,
          backgroundColor: theme.palette.info.main,
        }}
      />
      <legend align="right" className={classes.legendColor}>
        {`${Math.ceil(value)}%`}
      </legend>
      <div style={{ 
        position: "relative", 
        zIndex: 2, 
        padding: "8px 12px",
        minHeight: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        {props.children}
      </div>
    </fieldset>
  );
};

export default Fieldset;
